import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function PrivateRoute() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center bg-gray-50 text-slate-400 font-medium">
                Loading Admin...
            </div>
        );
    }

    return user ? <Outlet /> : <Navigate to="/admin/login" replace />;
}
